export const API_URL = process.env.VUE_APP_API_URL
export const BASE_API_URL = process.env.VUE_APP_BASE_API_URL
export default {
  API_URL,
  BASE_API_URL
}
